import request from '@/request/request'
let baseURL =  global.$config.api.system_url + '/emergency-server/'
// 新增救援资源
export function save(data) {
    return request({
        baseURL,
        url: '/emergencyTransportationResources/save',
        method: 'post',
        data
    })
}
//修改救援资源
export function update(data) {
    return request({
        baseURL,
        url: '/emergencyTransportationResources/update',
        method: 'post',
        data
    })
}
//查询救援资源列表
export function list(params) {
    return request({
        baseURL,
        url: '/emergencyTransportationResources/list',
        method: 'get',
        params
    })
}
//查询救援资源
export function detail(id) {
    return request({
        baseURL,
        url: '/emergencyTransportationResources/detail?id=' + id,
        method: 'get',
    })
}
//删除救援资源
export function remove(data) {
    return request({
        baseURL,
        url: '/emergencyTransportationResources/remove',
        method: 'post',
        data: { ...data, isFormData:true }
    })
}